@if (initialLoading()) {
  <div
    class="flex items-center justify-center py-12"
  >
    <div
      data-testid="online-store-form-loading"
      class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"
    ></div>
  </div>
} @else {
  <app-add-form
    data-testid="online-store-form-add-form"
    [title]="config.title"
    [formFields]="translatedFormFields()"
    [headerActions]="config.headerActions"
    [sectionButtons]="effectiveSectionButtons()"
    [tableSections]="tableSections()"
    [editMode]="editMode"
    [viewMode]="viewMode"
    [initialData]="combinedInitialData()"
    [loading]="loading()"
    (formAction)="onFormAction($event)"
    (sectionAction)="onSectionAction($event)"
    (formValueChanges)="onFormValueChanges($event)"
    (tableAction)="onTableAction($event)"
  ></app-add-form>
}

<!-- Warehouse Type Menu -->
<p-menu
  data-testid="online-store-form-warehouse-menu"
  #warehouseMenu
  [model]="warehouseMenuItems()"
  [popup]="true"
  [style]="{ width: '200px' }"
  styleClass="create-warehouse-menu"
></p-menu>

<!-- Confirmation dialog: delete product listing -->
<app-confirmation-dialog
  data-testid="online-store-form-delete-dialog"
  [visible]="showProductDeleteDialog()"
  (visibleChange)="showProductDeleteDialog.set($event)"
  [title]="productDeleteDialogTitle()"
  [message]="productDeleteDialogMessage()"
  [buttons]="productDeleteDialogButtons()"
  (emitOnClick)="onProductDeleteDialogAction($event)"
></app-confirmation-dialog>

<!-- Toast Messages -->
<p-toast data-testid="online-store-form-toast"></p-toast>
